<template>
    <v-snackbar
        v-model="snackbar.visible"
        :bottom="snackbar.y === 'bottom'"
        :left="snackbar.x === 'left'"
        :multi-line="snackbar.mode === 'multi-line'"
        :right="snackbar.x === 'right'"
        :timeout="snackbar.timeout"
        :top="snackbar.y === 'top'"
        :vertical="snackbar.mode === 'vertical'"
        :color="snackbar.color"
    >
        {{ snackbar.text }}
        <v-btn class="black--text" @click="snackbar.visible = false">Fechar</v-btn>
    </v-snackbar>
</template>

<script>
export default {
    name: "Message",
    data() {
        return {
            snackbar: {
                color: "error",
                visible: false,
                y: "top",
                x: "",
                mode: "vertical",
                timeout: 10000,
                text: "-",
            },
        };
    },
    mounted() {
        this.$root.$on("msgError", (msg) => {
            this.snackbar.text = msg;
            this.snackbar.color = "error";
            this.snackbar.visible = true;
        });
        this.$root.$on("msgSuccess", (msg) => {
            this.snackbar.text = msg;
            this.snackbar.color = "success";
            this.snackbar.visible = true;
        });
    },
};
</script>
